export default __webpack_public_path__ + "static/media/ic_expense.1e46c319.svg";